module.exports = __webpack_public_path__ + "static/img/szkfpt.8af09bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szkfpt.png
// module id = W0TS
// module chunks = 0